module.exports = __webpack_public_path__ + "4232aa940ac5a7453d1071a2dc44a099.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-4.png
// module id = 3262
// module chunks = 0